import type { ReactElement } from 'react'

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { ThemeProvider } from '@themenu/design-system'
import { Helmet, HelmetProvider } from 'react-helmet-async'
import { RouterProvider } from 'react-router-dom'
import { LocaleProvider, useLocale } from '../contexts/LocaleContext'
import { IntlLocaleProvider } from '../i18n/IntlLocaleProvider'
import { useLocalTheme } from '../hooks/useLocalTheme'
import { router } from '../routes/router'

const queryClient = new QueryClient()

const HelmetLocale = (): ReactElement => {
  const { locale } = useLocale()
  return <Helmet><html lang={locale} translate="no" /></Helmet>
}

export const Providers = (): ReactElement => {
  const { theme } = useLocalTheme()
  return (
    <LocaleProvider>
      <IntlLocaleProvider>
        <HelmetProvider>
          <HelmetLocale />
          <ThemeProvider theme={theme}>
            <QueryClientProvider client={queryClient}>
              <RouterProvider router={router} />
              <ReactQueryDevtools initialIsOpen={false} />
            </QueryClientProvider>
          </ThemeProvider>
        </HelmetProvider>
      </IntlLocaleProvider>
    </LocaleProvider>
  )
}
